// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPhoneOutlinedSvg from "@fishx/icons-svg/es/asn/PPhoneOutlined";
import FishxIcon from '../components/FishxIcon';

var PPhoneOutlined = function PPhoneOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPhoneOutlinedSvg
  }));
};

PPhoneOutlined.displayName = 'PPhoneOutlined';
export default React.forwardRef(PPhoneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPhoneOutlined.js
// module id = 3532
// module chunks = 0